export const INSERT_WORD_POPUP_WIDTH = 360;
